module.exports = __webpack_public_path__ + "static/gumgum.41827298.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/gumgum.png
// module id = 848
// module chunks = 73261030922168